<div id="pdfTable" class="pdfTable" #pdfTable style="width: 80%; position: fixed; top: -9999px; left: -9999px"></div>
